import { useContext, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  Back,
  Customer,
  HoldCart,
  PosScreen,
  Transaction,
  WhiteCart,
  WhiteCustomer,
  WhitePos,
  WhiteTransaction,
} from "../images";
import Modal from "../components/Reuseable/Modal";
import PrimaryButton from "../components/Reuseable/Buttons/PrimaryButton";
import { CartContext } from "../components/PosScreen/globalState/cartItem/cartItemContext";
import { useWagesStore } from "../components/PosScreen/globalState/allApis";

type Props = {
  screen?: any;
};
const posNavigation = [
  {
    id: 10,
    name: "Back",
    navigation: "/",
    icon: Back,
  },
  {
    id: 0,
    name: "POS",
    navigation: "/pos-screen",
    icon: PosScreen,
    secIcon: WhitePos,
  },
  {
    id: 4,
    name: "Hold Cart",
    navigation: "/hold-cart",
    icon: HoldCart,
    secIcon: WhiteCart,
  },
  {
    id: 2,
    name: "Transaction",
    navigation: "/transaction",
    icon: Transaction,
    secIcon: WhiteTransaction,
  },
  {
    id: 3,
    name: "Customer",
    navigation: "/customer",
    icon: Customer,
    secIcon: WhiteCustomer,
  },
];
const navigation = [
  {
    id: 0,
    name: "Dashboard",
    navigation: "/",
  },
  {
    id: 1,
    name: "POS",
    navigation: "/pos-screen",
  },
  {
    id: 2,
    name: "Category",
    navigation: "/category",
  },
  {
    id: 3,
    name: "Product",
    navigation: "/product",
  },
  {
    id: 4,
    name: "Purchase Stock",
    navigation: "/purchase-stock",
  },
  {
    id: 5,
    name: "Stock",
    navigation: "/stock",
  },
  {
    id: 6,
    name: "Sales Ledger",
    navigation: "/sales-ledger",
  },
  {
    id: 7,
    name: "Cut Piece",
    navigation: "/cut-piece",
  },
];
const SidebarLayout = (props: Props) => {
  const { screen } = props;
  const { state } = useContext(CartContext);
  const array = state?.cartItem;
  const initialPath = window?.location?.pathname;
  const [clickedIndex, setClickedIndex] = useState<string>(initialPath);
  const [openClearScreen, setOpenClearScreen] = useState(false);

  useEffect(() => {
    setClickedIndex(window?.location?.pathname);
  }, [window?.location?.pathname]);

  const isActive = (navPath: string) => {
    if (navPath === "/") {
      return clickedIndex === "/";
    }
    return clickedIndex.startsWith(navPath);
  };

  return (
    <>
      {screen === "posScreen" ? (
        <div className="font-sans w-[5rem] h-[95vh] bg-[#ffffff] border-r border-r-1 border-[#DEE2E6] overflow-hidden">
          <div className="w-full flex flex-col flex-[100%] justify-center items-center">
            {posNavigation?.map((nav: any) => (
              <Link
                to={
                  array.length > 0 && nav.name === "Back" ? "#" : nav.navigation
                }
                key={nav?.id}
                onClick={(e) => {
                  if (array.length > 0 && nav.name === "Back") {
                    e.preventDefault();
                    setOpenClearScreen(true);
                  } else {
                    setClickedIndex(nav.navigation);
                  }
                }}
                className={`w-full h-24 text-[13px] flex flex-col border border-b-1 items-center justify-center ${
                  isActive(nav.navigation) ? "text-white bg-primary" : ""
                }`}
              >
                <img
                  src={`${isActive(nav.navigation) ? nav?.secIcon : nav?.icon}`}
                  alt="ic"
                  className="w-6 mb-1"
                />
                <button className="w-full text-center">{nav?.name}</button>
              </Link>
            ))}
          </div>
        </div>
      ) : (
        <div className="font-sans w-[15.625rem] h-[95vh] bg-[#ffffff] border-r border-r-1 border-[#DEE2E6] overflow-hidden">
          <div className="w-full flex flex-col flex-[20%] p-10">
            <p className="p-2 text-lg border border-[#BDBDBD] text-center rounded">
              Jewellery POS
            </p>
          </div>
          <div className="w-full flex flex-col flex-[80%]">
            {navigation?.map((nav: any) => (
              <Link
                to={nav.navigation}
                key={nav?.id}
                onClick={() => setClickedIndex(nav.navigation)}
                className={
                  isActive(nav.navigation)
                    ? "w-full mb-0.5 text-white p-1.5 bg-primary"
                    : "mb-0.5 p-1.5 w-full"
                }
              >
                <button className={"w-full ml-4 text-left"}>{nav?.name}</button>
              </Link>
            ))}
          </div>
        </div>
      )}

      <Modal
        isOpen={openClearScreen}
        setIsOpen={setOpenClearScreen}
        children={
          <>
            <div className="w-full flex flex-col justify-center items-center p-4 font-medium">
              <p>Please clear your POS screen first !!!</p>
            </div>
          </>
        }
        title={"Alert"}
      />
    </>
  );
};

export default SidebarLayout;
